import logo from "@/assets/mesamind-logo.svg";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const services = [
  "Intermediação de Conflito",
  "Torne Sua Empresa Vendável",
  "Gerenciamento de Risco e Eficiência Operacional",
  "Governança Familiar",
  "Implementação e Gestão de Conselhos Consultivos",
];

const MesamindSection = () => (
  <section className="bg-background py-14 md:py-20">
    <div className="container mx-auto px-6">
      <div className="text-center mb-12">
        <a href="https://mesamind.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 group">
          <img src={logo} alt="Mesamind" className="h-8" />
          <ExternalLink className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors" />
        </a>
        <p className="font-body text-muted-foreground mt-4 text-[16px] italic font-normal leading-[1.5em]">
          Governança aplicada para momentos e decisões difíceis.
        </p>
        <p className="font-body text-foreground/80 mt-3 max-w-xl mx-auto text-[16px] font-normal leading-[1.5em]">
          A Mesamind ajuda sócios e líderes a tomarem decisões críticas sem destruir relações, valor ou legado.
        </p>
      </div>

      <div className="max-w-2xl mx-auto">
        <h3 className="font-heading text-[20px] font-bold leading-[1.4em] tracking-[-0.5px] text-center mb-6">Como podemos ajudar você:</h3>
        <div className="grid sm:grid-cols-2 gap-3">
          {services.map((s, i) => (
            <div key={i} className="flex items-center gap-3 p-4 rounded-lg border border-border bg-card hover:border-primary/40 transition-colors">
              <div className="w-2 h-2 rounded-full bg-primary shrink-0" />
              <span className="font-body text-[14px] font-normal text-card-foreground leading-[1.5em]">{s}</span>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <Button variant="cta-outline" size="lg" asChild>
            <a href="https://www.mesamind.com" target="_blank" rel="noopener noreferrer">
              Conheça mais sobre a Mesamind
              <ExternalLink className="w-4 h-4 ml-2" />
            </a>
          </Button>
        </div>
      </div>
    </div>
  </section>
);

export default MesamindSection;
